import { Button, Color, Radius, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { usePermissions } from '@dms/hook'
import { AccessType } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
    padding: Spacing.XXL,
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
    marginBottom: Spacing.M,
  },
})

interface Props {
  companyId: number
  onAdd?: () => void
}

const ZoneWorkspaceEmpty = (props: Props) => {
  const { companyId, onAdd } = props
  const { t } = useTranslation()
  const { hasPermission } = usePermissions(companyId)

  return (
    <View style={styles.container}>
      <Text style={styles.text}>
        <Trans>There are no workspaces added to this zone yet.</Trans>
      </Text>
      {hasPermission(AccessType.Update, 'workspace') && (
        <Button title={t('Add workspaces')} left="plus" testID="ZoneWorkspaceEmpty.Add" onPress={onAdd} />
      )}
    </View>
  )
}

export default ZoneWorkspaceEmpty
